/** API route map: URLS.Controller.ClientBadges */
export const ClientBadges = {
      Name: 'ClientBadges/',
      GetCompanyBadges: 'get-client-badges-list',
      AddCompanyBadges: 'add-client-badge',
      UpdateCompanyBadges: 'update-clientbadge',
      DeleteCompanyBadges: 'delete-clientbadge',
};
